module.exports = __webpack_public_path__ + "img/leicester-city.ba072121.png";